import React from 'react';
import LinkSelector from './link-selector/index.tsx';
import RepositorySelector from './repository-selector/index.tsx';
import Content, { type Props as ContentProps } from './view.tsx';

const injectedProps = {
	LinkSelector,
	RepositorySelector,
	showLinkSelector: true,
	showRepositorySelector: true,
} as const;

// @ts-expect-error - TS2344 - Type 'Props' does not satisfy the constraint '{ readonly LinkSelector: typeof WithAnalytics; readonly RepositorySelector: typeof WithAnalytics; readonly showLinkSelector: true; readonly showRepositorySelector: true; }'.
export type Props = Flow.Diff<ContentProps, typeof injectedProps>;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => <Content {...props} {...injectedProps} />;
